import React from 'react'
import { useCookieConsentStore } from '@/stores/cookieConsent'

const CookieBanner: React.FC = () => {
  const { 
    showBanner, 
    acceptAll, 
    rejectNonEssential, 
    showPreferencesPanelAction,
    showCookiePolicyAction
  } = useCookieConsentStore()

  if (!showBanner) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg">
      <div className="max-w-6xl mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          {/* Message */}
          <div className="flex-1">
            <p className="text-sm text-gray-700 leading-relaxed">
              We use cookies to improve your browsing experience, provide essential site functions, 
              analyze traffic, and personalize content. You can accept all cookies, reject non-essential 
              cookies, or manage your preferences. For more details, see our{' '}
              <button 
                onClick={showCookiePolicyAction}
                className="text-blue-600 hover:text-blue-800 underline"
              >
                Cookie Policy
              </button>.
            </p>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-2 md:ml-4">
            <button
              onClick={rejectNonEssential}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 transition-colors"
            >
              Reject Non-Essential
            </button>
            <button
              onClick={showPreferencesPanelAction}
              className="px-4 py-2 text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100 transition-colors"
            >
              Manage Preferences
            </button>
            <button
              onClick={acceptAll}
              className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-blue-600 rounded-md hover:bg-blue-700 transition-colors"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CookieBanner
